import React from 'react';
import { Card, CardContent } from 'src/components/PulseUI/Card';
import { twMerge } from 'tailwind-merge';

interface NotFoundProps {
  elevation?: number;
  color?: string;
  message: string;
  position?: 'flex-start' | 'center' | 'flex-end';
  size?: string;
  textAlign?: string;
}

const NotFound = ({
  elevation = 6,
  color = '#757575', // grey[600] equivalent
  message,
  position = 'center',
  size = '1.2rem',
  textAlign = 'center',
}: NotFoundProps) => {
  const positionClasses = {
    'flex-start': 'justify-start',
    center: 'justify-center',
    'flex-end': 'justify-end',
  };

  const textAlignClasses = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
  };

  // Map elevation to shadow classes (MUI elevation 6 ~ shadow-lg)
  const shadowClass = elevation >= 6 ? 'shadow-lg' : elevation >= 3 ? 'shadow-md' : 'shadow-sm';

  return (
    <div className={twMerge('flex w-full', positionClasses[position])}>
      <div className="w-full sm:w-1/2">
        <Card className={shadowClass}>
          <CardContent className="p-4">
            <p
              className={twMerge(textAlignClasses[textAlign as keyof typeof textAlignClasses])}
              style={{ color, fontSize: size }}
            >
              {message}
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default NotFound;
